export default __webpack_public_path__ + "static/media/bra-arte-11.db79212c.webp";